module.exports = __webpack_public_path__ + "static/media/with-charger.cc46c8fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/with-charger.png
// module id = 1139
// module chunks = 0